import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, timer } from 'rxjs';
import { tap, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TimerService {
  private countdown: number = 0;
  private countdownSubject = new BehaviorSubject(this.countdown);
  private countdownSubscription: Subscription | null = null;
  private isRecording: boolean = false;

  // Set the timer
  setTimer(seconds: number) {
    this.countdown = seconds;
    this.countdownSubject.next(this.countdown);
  }

  // Get timer observable
  getCountdownObservable(): Observable<number> {
    return this.countdownSubject.asObservable();
  }

  // Start / Resume the timer
  startTimer() {
    if (!this.isRecording && this.countdown > 0) {
      this.isRecording = true;
      this.countdownSubscription = timer(0, 10)
        .pipe(
          tap(() => this.countdown--),
          takeWhile(() => this.isRecording && this.countdown >= 0)
        )
        .subscribe(() => {
          this.countdownSubject.next(this.countdown);
        });
    }
  }

  // Pause the timer
  pausedOrStoppedTimer() {
    this.isRecording = false;
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
}
